// ------------------------------------
// props 輸入需求 :
// props.setReturnData : function             ( 回傳列出了多少個選項 )
// ------------------------------------

import React, { useEffect, useState } from 'react';
// import BarcodeScanner from '../add/BarcodeScanner';

const ResidentMobile =():React.JSX.Element=>{
    const [scannerBool, setScannerBool] = useState<Boolean>(false);
    const [scannedCode, setScannedCode] = useState<String|null>(null);

    const handleScan = (code:string) => {
      setScannedCode(code);
    };

    return  <div className='border'>
        <div onClick={()=>{setScannerBool(!scannerBool)}}>qrcode scanner</div>
        <div className='123'>
            {/* {scannerBool? <BarcodeScanner onScan={handleScan} />:null} */}
            {scannedCode && <p>Scanned Code: {scannedCode}</p>}
        </div>
    </div>
}
export default ResidentMobile